import { useState } from 'react'
import { useFormikContext } from 'formik'

import { NEWSBOARD_POST_FORM_FIELD_NAME_RECIPIENT } from '../../../NewsboardPostForm.constants'
import { CustomizeRecipientAudienceModal } from '../CustomizeRecipientAudienceModal'
import { getValidationSchema } from '../RecipientsField.utils'

import { parseSubmitValues } from './CustomizeRecipientAudienceField.utils'
import { RecipientsSelect } from './RecipientsSelect'

function CustomizeRecipientAudienceField({
  disabled,
  errorText,
  initialValues,
  isStaffUserAcc,
  setInitialValues,
  showError,
  ticker,
  onChange,
  ...restProps
}) {
  const [modal, setModal] = useState(false)

  const { values } = useFormikContext()

  function handleCloseModal() {
    setModal(null)
  }

  const validationSchema = getValidationSchema({
    initialValues,
    isStaffUserAcc,
  })

  function handleSubmit({ values }) {
    setInitialValues(values)
    onChange(parseSubmitValues(values))

    handleCloseModal()
  }

  function handleClick() {
    setModal(
      <CustomizeRecipientAudienceModal
        initialValues={initialValues}
        isStaffUserAcc={isStaffUserAcc}
        ticker={ticker}
        validationSchema={validationSchema}
        onCloseModal={handleCloseModal}
        onSubmit={handleSubmit}
      />
    )
  }

  return (
    <>
      <RecipientsSelect
        {...restProps}
        disabled={disabled}
        error={showError || errorText}
        initialValues={initialValues}
        isSubmitted={values[NEWSBOARD_POST_FORM_FIELD_NAME_RECIPIENT] && !modal}
        setInitialValues={setInitialValues}
        onChangeRecipientField={onChange}
        onClick={handleClick}
      />
      {modal}
    </>
  )
}

export default CustomizeRecipientAudienceField
